import color from "context/MaterialUITheme/color";
import digitalImage from "assets/Images/digital-loan.png";
import {
  Box,
  Container,
  List,
  ListItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function CHomeEquity() {
  const theme = useTheme();

  return (
    <Container disableGutters={useMediaQuery(theme.breakpoints.only("xs"))}>
      <Box bgcolor={color.white} p={{ md: 8, xs: 2 }}>
        <Typography
          mt={1}
          mb={2}
          variant="h3"
          color={color.black}
          letterSpacing={-0.8}
          fontFamily="Pro Display Semibold"
          fontSize={{ xs: "2rem", md: "3rem" }}
        >
          We provide on-demand access to your home equity so you can finance
          your life.
        </Typography>
        <Typography
          variant="h5"
          color={color.black}
          letterSpacing={-0.5}
          textAlign="justify"
          fontSize={{ xs: "1.2rem", md: "1.2rem" }}
        >
          Keep your low-interest rate mortgage and tap $25k to $250k of new
          money.
        </Typography>
        <Box
          p={0}
          mt={4}
          width="100%"
          maxWidth="lg"
          display="flex"
          alignItems={{ xs: undefined, sm: "center" }}
          flexDirection={{ xs: "column-reverse", sm: "row" }}
          justifyContent={{ xs: undefined, sm: "space-between" }}
        >
          <Box mt={{ xs: 2, md: 0 }}>
            <Typography
              variant="h3"
              mt={{ xs: 2, md: 0 }}
              fontSize={{ xs: "2rem", md: "3rem" }}
            >
              <span style={{ color: color.purple }}>NFTY</span>Door
              <br /> Home Equity Benefits:
            </Typography>
            <List>
              <ListItem disableGutters dense alignItems="flex-start">
                <Box mr={1} mt={0.4} display="inline" color={color.purple}>
                  •
                </Box>
                <Typography>1-minute application with no paperwork</Typography>
              </ListItem>
              <ListItem disableGutters dense alignItems="flex-start">
                <Box color={color.purple} display="inline" mr={1} mt={0.4}>
                  •
                </Box>
                <Typography>
                  Instant Pre-Qualification won't impact your credit score
                </Typography>
              </ListItem>
              <ListItem disableGutters dense alignItems="flex-start">
                <Box color={color.purple} display="inline" mr={1} mt={0.4}>
                  •
                </Box>
                <Typography>Choose between a HELOC and HELOAN</Typography>
              </ListItem>
              <ListItem disableGutters dense alignItems="flex-start">
                <Box color={color.purple} display="inline" mr={1} mt={0.4}>
                  •
                </Box>
                <Typography>Closing in as little as 3 days**</Typography>
              </ListItem>
              <ListItem
                disableGutters
                dense
                alignItems="flex-start"
                sx={{ mt: 3 }}
              >
                <Typography width={{ md: 400, xs: undefined }}>
                  ** Investment properties fund in as few as 3 business days.
                  Primary residences and Second homes differ.
                </Typography>
              </ListItem>
            </List>
          </Box>
          <Box
            component="img"
            alt="Hand holding cellphone showing screenshot of nftydoor page."
            src={digitalImage}
            width={{ xs: "100%", sm: "38%", md: "36%" }}
          />
        </Box>
      </Box>
    </Container>
  );
}
